import { feeds } from "@/mocks/observeData";
import { SectionHeading, SectionShell, StatusBadge } from "./common";

export default function LatestSection() {
  return (
    <SectionShell id="latest" className="bg-background-100/70 py-14 md:py-20">
      <div className="flex flex-col gap-6 lg:flex-row lg:items-end lg:justify-between">
        <SectionHeading
          eyebrow="UPDATES"
          title="最新跟进"
          desc="事件性信息往往随时间滚动变化，这里记录我们对公开信息的持续跟踪与状态更新。"
        />
        <div className="inline-flex shrink-0 items-center gap-2 self-start rounded-md border border-background-300 bg-background-50 px-3 py-2 text-sm text-foreground-600">
          <span className="relative flex h-2 w-2">
            <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-primary-400 opacity-75" />
            <span className="relative inline-flex h-2 w-2 rounded-full bg-primary-500" />
          </span>
          今日滚动更新中
        </div>
      </div>

      <div className="mt-9 grid grid-cols-1 gap-x-8 gap-y-6 lg:grid-cols-2">
        {feeds.map((f) => (
          <article
            key={f.id}
            className="relative flex gap-4 rounded-lg border border-background-200 bg-background-50 p-5"
          >
            <div className="flex flex-col items-center pt-1">
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-secondary-100 text-secondary-700">
                <i className="ri-file-list-3-line text-base" />
              </span>
              <span className="mt-2 h-full w-px bg-background-200" />
            </div>
            <div className="flex-1">
              <div className="flex flex-wrap items-center gap-x-3 gap-y-1.5 text-xs">
                <span className="inline-flex items-center gap-1.5 font-bold text-primary-700">
                  <i className="ri-price-tag-3-line" />
                  {f.category}
                </span>
                <time className="text-foreground-500">{f.time}</time>
                <StatusBadge status={f.status} />
              </div>
              <h3 className="mt-2 font-heading text-base font-bold leading-snug text-foreground-950 md:text-lg">
                {f.title}
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">{f.desc}</p>
            </div>
          </article>
        ))}
      </div>

      <div className="mt-9 flex justify-center">
        <a
          href="#topic"
          className="inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-secondary-500 px-6 py-3 text-sm font-bold text-background-50 transition-colors hover:bg-secondary-600 cursor-pointer"
        >
          回看热点议题
          <i className="ri-arrow-down-line" />
        </a>
      </div>
    </SectionShell>
  );
}